var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.buildYourJewelMode ? _c("Breadcrumb") : _vm._e(),
      _c("h3", { staticClass: "stones-title" }, [
        _vm._v(_vm._s(_vm.$t("stones_category")))
      ]),
      _c(
        "div",
        {
          staticClass: "stone-list container-fluid",
          class: { labgrown: _vm.query.labgrown },
          attrs: { id: "loading-table-container" }
        },
        [
          _vm.buildYourJewelMode && _vm.buildYourJewelStonesNumber > 1
            ? _c("BuildYourJewelSelectedStones", {
                on: { changeSelectedStones: _vm.search }
              })
            : _vm._e(),
          !_vm.buildYourJewelMode ||
          _vm.buildYourJewelStonesNumber == 1 ||
          _vm.buildYourJewelSelectedStones.length == 0
            ? _c("StoneFilters", {
                attrs: { buildYourJewelMode: _vm.buildYourJewelMode },
                on: { changeFilters: _vm.search }
              })
            : _vm._e(),
          _vm.results.length == 0 && !_vm.isLoading
            ? _c("div", { staticClass: "row mt-3" }, [
                !_vm.buildYourJewelMode
                  ? _c("div", { staticClass: "col-12 mb-5" }, [
                      _vm._v(" " + _vm._s(_vm.$t("stones.no_results")) + " ")
                    ])
                  : _vm._e(),
                _vm.buildYourJewelMode &&
                _vm.buildYourJewelStonesNumber > 1 &&
                _vm.buildYourJewelSelectedStones.length <
                  _vm.buildYourJewelStonesNumber
                  ? _c("div", { staticClass: "col-12 mt-3" }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("build_your_jewel.no_pairs")))
                      ]),
                      _c(
                        "button",
                        {
                          staticClass:
                            "edit-diamond-btn btn btn-primary mt-3 mb-5",
                          on: {
                            click: function($event) {
                              return _vm.setSelectedStones([])
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("build_your_jewel.edit_diamond"))
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm.results.length > 0 &&
          (!_vm.buildYourJewelMode ||
            _vm.buildYourJewelStonesNumber == 1 ||
            _vm.buildYourJewelSelectedStones.length <
              _vm.buildYourJewelStonesNumber)
            ? _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("ve-table", {
                      class: { "stones-table": _vm.isLoading },
                      attrs: {
                        columns: _vm.visibleColumns,
                        "table-data": _vm.results,
                        "row-style-option": _vm.rowStyleOption,
                        "cell-style-option": _vm.cellStyleOption,
                        eventCustomOption: { bodyRowEvents: _vm.bodyRowEvents },
                        cellSelectionOption: { enable: false },
                        "row-key-field-name": "id",
                        expandOption: _vm.expandOption
                      }
                    })
                  ],
                  1
                ),
                _vm.total > 0
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "stones-pagination" },
                        [
                          _c("ve-pagination", {
                            attrs: {
                              "page-index": _vm.pageIndex,
                              total: _vm.total,
                              "page-size": _vm.pageSize,
                              layout: ["prev", "pager", "next"]
                            },
                            on: {
                              "on-page-number-change": _vm.pageNumberChange
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }